import config from "config";
import helper from "actions/helper";

const v3 = "v3/";
const catalog = `${v3}catalog/`;

export default class RequestAbstract {
    _config = config;

    links = {
        token: "oauth/token",
        images: `${v3}images`,
        bonusMisty: `${v3}bonus/misty`,
        egisz: `${v3}egisz`,
        clinics: `${catalog}clinics`,
        rentgenDoze: `${catalog}rentgen-doze`,
        insurance: `${catalog}insurance`,
        clientNotes: `${catalog}client-notes`,
        clients: `${catalog}clients`,
        clientsDetails: `${catalog}clients/details`,
        doctors: `${catalog}employees`,
        paymentWay: `${catalog}payment-way`,
        paymentWayBranch: `${catalog}payment-way-branch`,
        doctorSchedules: `${catalog}doctor-schedules`,
        doctorSchedulesShort: `${catalog}doctor-schedules/short/`,
        doctorSchedulesShortList: `${catalog}doctor-schedules/short-list`,
        cabinets: `${catalog}cabinets`,
        shifts: `${catalog}shifts`,
        visits: `${catalog}visits`,
        documentTemplate: `${catalog}document-template`,
        fileStorage: `${catalog}file-storage`,
        recommendationTypes: `${catalog}recommendation-types`,
        reasons: `${catalog}reasons`,
        treatmentPlans: `${catalog}treatment-plans`,
        clientRelations: `${catalog}client-relations`,
        anketaQuestions: `${catalog}anketa-questions`,
        anketaQuestionnaireStat: `${catalog}anketa-questionnaire-stat`,
        anketaAnswers: `${catalog}anketa-answers`,
        cities: `${catalog}cities`,
        invoices: `${catalog}invoices`,
        invoicesDetails: `${catalog}invoices/details`,
        priceCategories: `${catalog}price-categories`,
        priceLists: `${catalog}price-lists`,
        repeatedVisits: `${catalog}repeated-visits`,
        report: `${v3}report`,
        priceCategoriesCurrent: `${catalog}price-categories/current`,
        treatmentTasks: `${catalog}treatment-tasks`,
        accountHistory: `${catalog}account-history`,
        messages: `${catalog}messages`,
        teethDefects: `${catalog}teeth-defects`,
        phrase: `${catalog}phrase`,
        medSection: `${catalog}med-section`,
        medInspection: `${catalog}med-inspection`,
        medDiary: `${catalog}med-diary`,
        jasperReports: `${catalog}jasper-reports`,
        files: `${v3}files`,
        pdfToken: `${v3}pdf/file/token/`,
        clientDocumentsHistory: `${catalog}client-documents-history`,
        employees: `${catalog}employees`,
    };

    get link() {
        return "";
    }

    async postForm(link, data, headers = {}) {
        const body = Object.entries(data).map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value)).join('&');

        return await this.load(link, {
            method: 'POST',
            headers: {
                ...headers,
                'Content-Type': 'application/x-www-form-urlencoded',
                'Language': helper.currentLanguage,
            },
            body
        });
    }

    async getAll() {
        return await this.getAllFiltered();
    }

    async search(limit, filter = [], sort = [], props) {
        return await this.getFiltered(this.link, filter, sort, {
            page: 0,
            pageSize: limit || 100000
        }, props);
    }

    async getAllFiltered(filter = [], sort = [], props) {
        return await this.getFiltered(this.link, filter, sort, {
            page: 0,
            pageSize: 100000
        }, props);
    }

    async getFiltered(link, filter, sort, paging, props = {}) {
        return await this.post(link, { filter, sort, paging, ...props });
    }

    async add(info) {
        return await this.post(this.link + "/add/", info);
    }

    async create(info) {
        return await this.post(this.link + "/create/", info);
    }

    async addn(info) {
        return await this.post(this.link + "/add-n/", info);
    }

    async update(id, info) {
        return await this.post(this.link + "/update/" + id, info);
    }

    async updateIndex(id, index) {
        return await this.post(this.link + "/update-index/" + id, { index });
    }

    async addUpdate(info) {
        if (info?.id)
            return this.update(info.id, info);

        return this.add(info);
    }

    async upload(info) {
        return await this.postFormData(this.link + "/upload", info);
    }

    async replace(id, info) {
        return await this.postFormData(this.link + "/replace/" + id, info);
    }

    async copy(id, info) {
        return await this.post(this.link + "/copy/" + id, info);
    }

    async delete(id) {
        return await this.get(this.link + "/delete/" + id);
    }

    async deletep(id, info) {
        return await this.post(this.link + "/delete/" + id, info);
    }

    async clone(id, info) {
        return await this.post(this.link + "/clone/" + id, info);
    }

    async get(link) {
        return await this.loadWithAuth(link, { method: 'GET' });
    }

    async post(link, props) {
        return await this.loadWithAuth(link, {
            method: 'POST',
            body: JSON.stringify(props)
        });
    }

    async postFormData(link, props, callback) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", 'Bearer ' + localStorage.token);
        const formdata = new FormData();

        for (let property in props) {
            if (props.hasOwnProperty(property)) {
                if (property === "fileInfo") {
                    if (props.fileInfo.image) {
                        formdata.append("image", props.fileInfo.image, props.fileInfo.name);
                        const requestOptions = {
                            method: 'POST',
                            headers: myHeaders,
                            body: formdata,
                            redirect: 'follow'
                        };

                        fetch(this.getFullLink(link), requestOptions)
                            .then(response => response.text())
                            .then(result => {
                                callback && callback(null, result);
                            })
                            .catch(error => {
                                callback && callback(error);
                            });

                    } else if (props.fileInfo.type === "SNAPSHOT") {
                        formdata.append("file", props.fileInfo.file, props.fileInfo.name);
                        formdata.append("new_file", props.fileInfo.file, props.fileInfo.name);
                    } else {
                        formdata.append("file", props.fileInfo.file, props.fileInfo.name);
                    }
                } else
                    formdata.append(property, props[property]);
            }
        }

        return await this.loadWithAuth(link, {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        }, false);
    }

    async loadWithAuth(link, props = {}, jsonCont = true) {
        if (!props.headers)
            props.headers = {};

        props.headers["Authorization"] = 'Bearer ' + localStorage.token;
        props.headers["Language"] = helper.currentLanguage;
        if (jsonCont)
            props.headers["Content-Type"] = 'application/json';

        return await this.load(link, props);
    }

    async load(link, props) {
        let resp = {};

        let status = 0;
        try {
            const response = await fetch(this.getFullLink(link), props);
            status = response.status;

            resp = await response.json();
        } catch (error) {
            resp = { code: "error", status };
        }

        if (status === 401) {
            if (!globalThis.appView.state.loggedIn)
                helper.showRequestError(resp, helper.tr("server.loginPassError"));
            else
                helper.logout();

            return {};
        }

        if (resp?.code !== "success" &&
            !link.includes(this.links.token) &&
            !link.includes(this.links.bonusMisty) &&
            !link.includes("sign-certificates"))
            helper.showRequestError(resp);

        return resp;
    }

    getFullLink(link) {
        return "/api/" + link;
    }

    getSortField(sortKeyOrArr) {
        return (Array.isArray(sortKeyOrArr) ? sortKeyOrArr : [sortKeyOrArr]).map(key => {
            const isDesc = key[0] === "-";
            const direction = isDesc ? "DESC" : "ASC";
            const field = isDesc ? key.substring(1) : key;

            return { field, direction };
        });
    }

}
